module.exports = __webpack_public_path__ + "static/img/img_logo.a5bc65d6.png";